import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ResizedEvent } from '../../../../core/model/resized-event';
import { UserPeticiones } from '../../../../core/model/users';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { UsersService } from '../../../../core/services/users.service';
import { ModalConfirmationComponent } from '../../../../utils/modal-confirmation/modal-confirmation.component';
import { Page } from '../../../../core/model/page';
import { TemplateField, SelectValue } from '../../../../core/model/template-field';
import { CampoSolicitud } from '../../../../core/model/campo-solicitud';
import { Cliente } from '../../../../core/model/cliente';
import { ClientesService } from '../../../../core/services/clientes.service';

@Component({
  selector: 'app-nuevousuario',
  templateUrl: './nuevousuario.component.html',
  styleUrls: ['./nuevousuario.component.css']
})
export class NuevousuarioComponent implements OnInit, OnDestroy {
  @ViewChild('tblusers') table: DatatableComponent;

  Title: string;
  Description: string;
  Padre: string;
  Hijo: string;

  private subscription;
  private subscription_change;
  private subscription_petis;

  isDocoutUser: boolean;
  noHayPeticiones = false;
  requestProcessing = false;
  statusCode: number;
  messageToShow: string;
  filtersTable: TemplateField[];
  filtersValue: any[];

  clients: Cliente[] = [];

  page = new Page();


  allPeticiones: UserPeticiones[];

  customMessages = {
    emptyMessage: 'No hay peticiones de usuarios disponibles',
    totalMessage: 'Total',
    selectedMessage: 'Selección'
  };
  customClasses = {
    sortAscending: 'fas fa-sort-up',
    sortDescending: 'fas fa-sort-down',
    pagerLeftArrow: 'fas fa-chevron-left',
    pagerRightArrow: 'fas fa-chevron-right',
    pagerPrevious: 'fas fa-step-backward',
    pagerNext: 'fas fa-step-forward',
  };

  constructor(private translateService: TranslateService,
    private authService: AuthenticationService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private userservice: UsersService,
    private clientsService: ClientesService) { }


  // region "Initialize"

  ngOnInit() {
    this.page.pageNumber = 0;
    this.page.size = 10;
    this.SetEnviroment();
    this.InitLanguage();
    this.getUsersPaginated();
  }

  SetEnviroment() {
    this.authService.isDocOutUser()
      .then((isDocUser: boolean) => {
        this.isDocoutUser = isDocUser;
        if (this.isDocoutUser) {
          this.clientsService.getAllClientes()
            .subscribe((clients: Cliente[]) => {
              this.clients = clients;
              this.filtersTable = this.getFiltersTable();
            });
        } else {
          this.filtersTable = this.getFiltersTable();
         }
      });

    this.authService.getClienteName$().subscribe(beadcrumbDad => {
      this.Padre = beadcrumbDad;
    });
  }
  InitLanguage() {
    this.subscription = this.translateService.get(['usuarios'])
      .subscribe(values => { this.TranslateText(values); });

    this.subscription_change = this.translateService.onLangChange.subscribe(() => {
      this.translateService.get(['usuarios'])
        .subscribe(values => { this.TranslateText(values); });
    });
  }
  TranslateText(values: any) {
    this.Title = values['usuarios']['cabecera'];
    this.Description = values['usuarios']['descripcionpeticion'];
    this.Hijo = values['usuarios']['cabecera'];
  }

  getUsersPaginated(resetPage?: boolean) {
    this.preProcessLoader('Cargando usuarios...');
    if (resetPage) {
      this.page.pageNumber = 0;
    }
    const inicio = this.page.size * this.page.pageNumber;
    const fin = inicio + (+this.page.size);

    this.getPeticiones(inicio, fin);
  }


  // endregion

  // region "Detalle"

  getPeticiones(inicio: number, fin: number) {

    this.preProcessLoader('Cargando peticiones de usuarios...');
    this.subscription_petis = this.userservice.getUsersPetitions(inicio, fin, this.filtersValue)
      .subscribe(
        data => {
          this.allPeticiones = data.dataList;
          this.page.totalElements = data.totalResults;
          this.noHayPeticiones = false;
          this.requestProcessing = false;
          if (this.allPeticiones.length <= 0 || this.allPeticiones == null) {
            this.noHayPeticiones = true;
          }

        },
        errorCode => {
          this.statusCode = 500; // errorCode
          this.noHayPeticiones = true;
          this.subscription = this.translateService.get(['mensajes'])
            .subscribe(values => {
              this.toastr.warning(values['mensajes']['nosolicitudes'],
                values['mensajes']['nosolicitudestitle']);
            });
        });
  }
  private getFiltersTable(): TemplateField[] {
    const filtros = [];

    if (this.isDocoutUser) {
      const clientFilterField = new TemplateField();
      clientFilterField.id = 1;
      clientFilterField.tipo = 'ARRAY';
      clientFilterField.nombre = 'CLIENT';
      clientFilterField.multivalue = false;
      clientFilterField.descripcion = this.translateService.instant('usuarios.columns.Client');
      clientFilterField.defaultValues = this.clients.map((client: Cliente) =>
        new SelectValue(client.ID, client.NOMBRE, client.DESCRIPCION, null, null));

      filtros.push(clientFilterField);
    }
    const userFilterField = new TemplateField();
    userFilterField.id = 1;
    userFilterField.tipo = 'STRING';
    userFilterField.nombre = 'USER';
    userFilterField.multivalue = false;
    userFilterField.descripcion = this.translateService.instant('usuarios.columns.User');

    const emailFilterField = new TemplateField();
    emailFilterField.id = 1;
    emailFilterField.tipo = 'STRING';
    emailFilterField.nombre = 'EMAIL';
    emailFilterField.multivalue = false;
    emailFilterField.descripcion = this.translateService.instant('usuarios.columns.Email');

    filtros.push(userFilterField);
    filtros.push(emailFilterField);

    return filtros;
  }

  preProcessLoader(mensaje: string) {
    this.messageToShow = mensaje;
    this.statusCode = null;
    this.requestProcessing = true;
  }

  // region "Confirmation Modal"
  public showConfirmationModal(usuario: UserPeticiones): void {
    const modal = this.modalService.show(ModalConfirmationComponent);
    (<ModalConfirmationComponent>modal.content).showConfirmationModal(
      'Confirmar alta usuario',
      'Va a confirmar el alta del Usuario ' + usuario.NOMBRE + ' ' + usuario.APELLIDOS + ', en el sistema ¿Está seguro/a?',
      '',
      'Si',
      'No',
      true,
      'fa-user fa-3x',
      'bg-primary'
    );

    (<ModalConfirmationComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        // when pressed Yes
        this.altaNuevoUsuario(usuario);

      } else if (result === false) {
        // when pressed No
      } else {
        // When closing the modal without no or yes
      }
    });
  }


  altaNuevoUsuario(usuario: UserPeticiones) {
    this.preProcessLoader('Guardando usuario en el sistema...');
    this.subscription_petis = this.userservice.createUserPeticion(usuario.Id)
      .subscribe(
        successCode => {
          this.toastr.success('Usuario guardado correctamente', 'Usuario añadido');
          this.statusCode = successCode;
          this.getUsersPaginated(true);
        },
        errorCode => {
          this.statusCode = 500; // errorCode
          this.noHayPeticiones = true;
          this.subscription = this.translateService.get(['mensajes'])
            .subscribe(values => {
              if (errorCode.error != null) {
                this.toastr.warning(errorCode.error.Message, 'Ha ocurrido un error');
              } else {
                this.toastr.warning(values['mensajes']['nodata'], values['mensajes']['nodatatitle']);
              }
            });
          this.getUsersPaginated(true);
        });
  }

  // endregion

  ngOnDestroy() {
    // console.log('Clear usuarios consulta');

    if (this.subscription != null) { this.subscription.unsubscribe(); }
    if (this.subscription_change != null) { this.subscription_change.unsubscribe(); }
    if (this.subscription_petis != null) { this.subscription_petis.unsubscribe(); }

    this.translateService = null;
    this.authService = null;
    this.userservice = null;
    this.modalService = null;
    this.toastr = null;
  }

  onResized(event: ResizedEvent): void {
    if (this.table) {
      setTimeout(() => {
        this.table.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  setPage(pageInfo: any) {
    this.page.pageNumber = pageInfo.offset;
    this.getUsersPaginated();
  }

  searchFilters(filtros: TemplateField[]) {
    this.page.pageNumber = 0;
    // const campos: TemplateField[] = filtros.map(filtro => filtro.toTemplateField());
    this.filtersValue = filtros.map((filtro: TemplateField) => filtro.toDTO());
    this.getUsersPaginated();
  }

}
